export default "__VITE_ASSET__rnaSC6VS__"